import React from "react";

const SIZE_CLASS = {
  sm: "dashboard-avatar-sm",
  md: "dashboard-avatar",
  lg: "dashboard-avatar-lg",
};

/**
 * Dashboard Avatar — sm 24px · standard 32px · lg 40px. Circle; image or uppercase initials.
 */
const DashboardAvatar = ({
  size = "md",
  src,
  alt = "",
  initials,
  className = "",
  imgClassName = "",
  onError,
}) => {
  const shellClass = `${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`.trim();
  const showInitials = !src && initials;

  return (
    <span className={shellClass} role={src ? undefined : "img"} aria-label={alt || initials}>
      {src ? (
        <img
          src={src}
          alt={alt}
          onError={onError}
          className={`h-full w-full object-cover ${imgClassName}`.trim()}
        />
      ) : showInitials ? (
        <span className="dashboard-avatar-initials">{initials}</span>
      ) : null}
    </span>
  );
};

export default DashboardAvatar;
